import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpApiService } from 'src/app/shared/services/http.api.service';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { EraPecEccAquaticEu, EraPecEccAquaticCompound, EraPecEccAquaticDataTransaction, EraPecEccAquaticModel, EraPecEccAquatic, EraPecEccAquaticBodyGet } from '../era-pec-ecc-aquatic.model';

@Injectable({
  providedIn: 'root'
})
export class ERAPecEccAquaticBamsApiService extends HttpApiService {

  override apiUrl: string = environment.BAMS_Api_URL;

  private eraApiPrefix: string = 'api/eraPecEccAquatic/';

  getModelsByDisciplinePkAndGeography(disciplinePk: number, geographyPk: number, geographyType: string):Observable<EraPecEccAquaticModel[]> {;
    const endpoint = `${this.eraApiPrefix}getModelsByDisciplinePkAndGeography/${disciplinePk}/${geographyPk}/${geographyType}`;
    return this.get(endpoint)
      .pipe(map((data: any) => data.Value));
  }

  getCompoundsByProjectPkAndDisciplinePk(projectPk: number, disciplinePk: number):Observable<EraPecEccAquaticCompound[]> {;
    const endpoint = `${this.eraApiPrefix}getCompoundsByProjectPkAndDisciplinePk/${projectPk}/${disciplinePk}`;
    return this.get(endpoint)
      .pipe(map((data: any) => data.Value));
  }

  insertUpdateAndDeleteEraPecEccAquatic(dataTransaction: EraPecEccAquaticDataTransaction): Observable<boolean> {
    const body = JSON.stringify(dataTransaction);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    let endpoint = `${this.eraApiPrefix}insertUpdateAndDeleteEraPecEccAquatic`;
    return this.put(endpoint, body, headers).pipe(map((data: any) => data.Value));
  }

  getPecEccAquaticByProjectPk( aquaticGetBody: EraPecEccAquaticBodyGet ): Observable<EraPecEccAquatic> {
    const body = JSON.stringify(aquaticGetBody);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const endpoint = `${this.eraApiPrefix}getPecEccAquaticByProjectPk`;
    return this.put(endpoint, body, headers).pipe(map((data: any) => data.Value));
  }

  getModelsByCompartmentPkAndGeography(compartmentPk: number, geographyPk: number, geographyType: string, disciplinePk: number):Observable<EraPecEccAquaticModel[]> {;
    const endpoint = `${this.eraApiPrefix}getModelsByCompartmentPkAndGeography/${compartmentPk}/${geographyPk}/${geographyType}/${disciplinePk}`;
    return this.get(endpoint)
      .pipe(map((data: any) => data.Value));
  }
}
